import { createContext, useContext } from 'react';

export const ExpandContext = createContext({
  expandedNodes: [],
  expandedSources: {},
  onExpandNode: (id: number | string) => {},
  onExpandSource: (id: number) => {},
});

export function useExpandedNodes() {
  return useContext(ExpandContext);
}
